import {
  mapGetters,
} from 'vuex';
import {
  DEFAULT_IMAGE,
} from '@/utils/const';
import Api from '@/utils/api';
import helpers from '@/mixins/helpers';

export default {
  props: {
    document: {
      type: Object,
      default: () => {},
    },
  },
  mixins: [
    helpers.general,
  ],
  data() {
    return {
      defaultImage: DEFAULT_IMAGE,
      linkView: null,
      linkPrint: null,
    };
  },
  computed: {
    ...mapGetters({
      user: 'user',
    }),
  },
  beforeDestroy: function () {
    if (this.linkView !== null) {
      URL.revokeObjectURL(this.linkView);
    }
    if (this.linkPrint !== null) {
      URL.revokeObjectURL(this.linkPrint);
    }
  },
  methods: {
    closeModal() {
      if (this.linkView !== null) {
        URL.revokeObjectURL(this.linkView);
        this.linkView = null;
      }
    },
    /**
     * Remove holder for show popup
     */
    removeHolder() {
      this.$modal.show('dialog', {
        title: 'Are you sure delete this document?',
        buttons: [{
          title: 'Yes',
          handler: () => {
            this.removeDocument();
            this.$modal.hide('dialog');
          },
        }, {
          title: 'No',
        }],
      });
    },

    /**
     * Remove holder for show popup
     */
    removeDocument() {
      Api.documentation
        .remove(this.document.GUID)
        .then((response) => {
          if (response.data.Status) {
            this.$emit('refresh');
          }
        });
    },

    openDocument() {
      if (this.linkView !== null) {
        this.$modal.show('preview-doc-modal');
      }
    },
    openPdf() {
      const myWindow = window.open('', '', 'width=900,height=500');
      myWindow.document.write(`<embed style="width:100%;height:100%" src="${this.linkPrint}" >`);
      myWindow.document.close();
    },

    printDocument() {
      if (this.linkPrint) {
        const myWindow = window.open('', '', 'width=900,height=500');
        myWindow.document.write(`<img src="${this.linkPrint}">`);
        myWindow.document.close();
        myWindow.focus();
        setTimeout(() => {
          myWindow.print();
          myWindow.close();
        }, 300);
      }
    },
    printPdf() {
      if (this.linkPrint) {
        const myWindow = window.open('', '', 'width=900,height=500');
        myWindow.document.write(`<embed style="width:100%;height:100%" src="${this.linkPrint}" >`);
        myWindow.document.close();
        myWindow.focus();
      }
    },
    /**
     * Downoad file
     */
    downloadFile() {
      Api.documentation
        .fileDownload(this.document.GUID, this.document.Name)
        .then((response) => {
          if (response.data) {
            this.donwloadFileOnContent(response.data, this.document.Name);
          } else {
            this.$root.$emit('notification', {
              message: response.data.Message,
              type: 'error',
              show: true,
            });
          }
        });
    },

    /**
     * View file
     */
    viewFile() {
      Api.documentation
        .fileView(this.document.GUID)
        .then((response) => {
          if (response.status === 200) {
            if (response.data.type === 'application/pdf') {
              const blob = new Blob([response.data], {
                type: 'application/pdf',
              });
              this.linkPrint = URL.createObjectURL(blob);
              this.openPdf();
            } else {
              this.linkView = URL.createObjectURL(response.data);
              this.openDocument();
            }
          }
        });
    },

    /**
     * Print file
     */
    printFile() {
      Api.documentation
        .filePrint(this.document.GUID)
        .then((response) => {
          if (response.status === 200) {
            if (response.data.type === 'application/pdf') {
              const blob = new Blob([response.data], {
                type: 'application/pdf',
              });
              this.linkPrint = URL.createObjectURL(blob);
              this.printPdf();
            } else {
              this.linkPrint = URL.createObjectURL(response.data);
              this.printDocument();
            }
          }
        });
    },
  },
};
